import { I18N_REDUCER } from '../constants';
import { useCustomSelector } from './useCustomSelector';

import { TI18nSelector, TEqualityFunction } from '../types';

export const useI18nSelector = <TSelected>(selector: TI18nSelector<TSelected>, equalityFn?: TEqualityFunction<TSelected>) => {
    return useCustomSelector<TSelected, typeof I18N_REDUCER>(I18N_REDUCER, selector, equalityFn);
};
